import React from 'react';

export const Loader: React.FC = () => {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-white bg-opacity-80 backdrop-blur-sm transition-opacity duration-300">
            <div className="relative flex flex-col items-center">
                {/* Modern Spinner */}
                <div className="h-16 w-16 animate-spin rounded-full border-4 border-gray-200 border-t-blue-600"></div>

                {/* Pulse Effect */}
                <div className="absolute top-0 left-0 h-16 w-16 animate-ping rounded-full border-4 border-blue-400 opacity-20"></div>

                <p className="mt-4 text-lg font-medium text-gray-700 animate-pulse">Loading...</p>
            </div>
        </div>
    );
};
